import { MultiplicityType, Parameter } from '@sa/rep-core';

export class MapExportQuery {
  public title?: string;
  public source?: string;
  public dataSourceIdentifier?: string;
  public parameters: Parameter[] = [];

  public toDTO(useReportingV2: boolean) {
    if (![this.title, this.dataSourceIdentifier].every(Boolean)) {
      throw new Error('Модель экспорта не готова'); // TODO: Перевести
    }

    if (useReportingV2) {
      return {
        "title": this.title,
        "source": this.source,
        "id": this.dataSourceIdentifier,
        "parameters": this.parameters
      }
    } else {
      return {
        "title": this.title,
        "source": this.source,
        "id": this.dataSourceIdentifier,
        "reportDefinition": {
          "parameters": this.parameters,
        }
      }
    }
  }
}